import React from "react";
import clsx from "clsx";
import baseStyles from "../../Compare.module.scss";
import styles from "./Powertrains.module.scss";
import Icon from "../../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import { useGetCompareGrades } from "../../compareHooks";
import SectionCollapse from "../SectionCollapse";
import { CollapseSection, trackExpandedItem } from "../../../../../../utils/tracking";
import { useCompareContext } from "../../CompareContext";
import { useCarConfigLabel } from "../../../../../../utils/labelUtils";

const Powertrains: React.FC = (): JSX.Element => {
    const { openedCollapses, setOpenedCollapses } = useCompareContext();
    const grades = useGetCompareGrades();

    const carConfigLbxComparePowerTrains = useCarConfigLabel("carConfigLbxComparePowerTrains");

    return (
        <SectionCollapse
            open={openedCollapses.includes(CollapseSection.SectionPowertrains)}
            onChange={() => {
                const isOpen = openedCollapses.includes(CollapseSection.SectionPowertrains);

                trackExpandedItem(isOpen, CollapseSection.SectionPowertrains);

                setOpenedCollapses(
                    isOpen
                        ? openedCollapses.filter((item) => item !== CollapseSection.SectionPowertrains)
                        : [...openedCollapses, CollapseSection.SectionPowertrains],
                );
            }}
            summary={carConfigLbxComparePowerTrains}
        >
            <div className={baseStyles["compare-card"]}>
                <div className={baseStyles["card-body"]}>
                    {grades.map((grade) => (
                        <div key={`${grade.id}-${grade.name}}`}>
                            <ul className={clsx(baseStyles["compare-list"], styles.powertrains)}>
                                {grade.wheeldrives.map((wheeldrive) => (
                                    <li key={wheeldrive.id}>
                                        <Icon
                                            variant={wheeldrive.internalCode === "4WD" ? "awd" : "fwd"}
                                            sizing="sm"
                                            aria-hidden="true"
                                        />
                                        {wheeldrive.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                    {/* Shows empty div when second item isn't defined yet (layout reasons) */}
                    {grades.length < 2 && <div />}
                </div>
            </div>
        </SectionCollapse>
    );
};

export default Powertrains;
